document.addEventListener('click', (e) => {
  const openTrigger = e.target.closest('.rating-wrapper, a[href="#okendo-reviews-drawer"]');
  const closeTrigger = e.target.closest('.reviews-drawer__close');
  const overlay = e.target.closest('.reviews-drawer-overlay');

  const drawer = document.getElementById('okendo-reviews-drawer');
  const drawerOverlay = document.querySelector('.reviews-drawer-overlay');

  if (!drawer || !drawerOverlay) return;

  /* OPEN */
  if (openTrigger) {
    if (openTrigger.tagName === 'A') e.preventDefault();
    drawer.classList.add('is-open');
    drawerOverlay.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    return;
  }

  /* CLOSE */
  if (closeTrigger || overlay) {
    drawer.classList.remove('is-open');
    drawerOverlay.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }
});




 
window.addEventListener("load", function() {
  setTimeout(function() {
    document.querySelectorAll(".oke-w-recommendsModule-text").forEach(function(el) {
      el.textContent = "Would recommend this product to a friend";
    });
  }, 1500);
});

document.addEventListener("DOMContentLoaded", function() {

  const widgetDiv = document.getElementById('okendo-widget');
  if (!widgetDiv) return;

  // Prefer a product ID explicitly set by a custom-product-review-stars block
  // with "tie drawer to selected product" enabled (first match wins).
  const override = document.querySelector('[data-okendo-product-group-id]');
  let productGroupId = override ? override.getAttribute('data-okendo-product-group-id') : null;

  if (!productGroupId) {
    // Fallback: scan JSON-LD on the page for a product.
    const ldJsonScripts = document.querySelectorAll('script[type="application/ld+json"]');
    const productDataList = Array.from(ldJsonScripts).map(s => {
      try {
        return JSON.parse(s.textContent);
      } catch(e) {
        return null;
      }
    }).filter(d => d && d.productGroupID);

    if (productDataList.length === 0) {
      widgetDiv.remove();
      return;
    }

    productGroupId = productDataList[0].productGroupID;
  }

  widgetDiv.setAttribute(
    'data-oke-reviews-product-id',
    'shopify-' + productGroupId
  );


});




  ((document, window) => {
  const reviewsWidgetHolder = document.querySelector('[data-oke-widget]');

  if (!reviewsWidgetHolder) return;

  const applySettings = (api) => {
    api.setWidgetSettings({
      subscriberId: "dd2481cc-501c-4fcf-965b-37696229c8b9",
      reviewsWidget: {
        showWhenEmpty: true,
        reviews: {
          list: {
            layout: { name: "minimal" },
            media: { show: false }
          }
        }
      }
    });
  };

  // If Okendo's API is already on window, configure immediately. Otherwise
  // install a property-setter trap that fires the moment Okendo assigns the
  // global, w/o a mutation observer or set timeout.
  if (window.okeWidgetApi) {
    applySettings(window.okeWidgetApi);
  } else {
    let stored;
    Object.defineProperty(window, 'okeWidgetApi', {
      configurable: true,
      enumerable: true,
      get() { return stored; },
      set(value) {
        stored = value;
        // Replace this accessor with a normal data property so Okendo's
        // subsequent reads/writes behave like any other window global.
        Object.defineProperty(window, 'okeWidgetApi', {
          value,
          writable: true,
          configurable: true,
          enumerable: true,
        });
        applySettings(value);
      },
    });
  }
})(document, window);
